// extracted by mini-css-extract-plugin
export default {"stepHeading":"LoanConfigurationStepWrapper_stepHeading__S4ArV","stepName":"LoanConfigurationStepWrapper_stepName__QFH4W"};